import React, { useEffect, useRef, useState } from 'react'
import './Cenik.scss'

const Cenik = () => {
  const [visibleCards, setVisibleCards] = useState([])
  const sectionRef = useRef(null)

  const pricingPlans = [
    {
      id: 1,
      name: 'Základní kurz',
      icon: "🚗",
      price: '22.900',
      originalPrice: null,
      specialOffer: null,
      description: 'Kompletní základní kurz pro získání řidičského oprávnění skupiny B',
      popular: true,
      vehicle: 'Škoda Fabia Combi',
      duration: 'cca 2 měsíce',
      features: [
        '28 hodin povinné praktické jízdy',
        'První 2 hodiny na autocvičišti Pánov',
        'Doprava na autocvičiště zdarma',
        'Procvičení dopravních situací',
        'Přístup k e-learningovým materiálům',
        'Zapůjčení učebnice (záloha 200 Kč)',
        'Přihlášení k první zkoušce zdarma'
      ],
      included: [
        'Teoretická příprava',
        'Praktické jízdy',
        'Výukové materiály',
        'Doprava na cvičiště'
      ]
    },
    {
      id: 2,
      name: 'Expresní Solitér',
      icon: "🚗",
      price: '30.900',
      originalPrice: null,
      specialOffer: null,
      description: 'Rychlý kurz s absolutní předností pro zaneprázdněné',
      popular: false,
      vehicle: 'Škoda Fabia Combi',
      duration: 'cca 1 měsíc',
      features: [
        'Vše ze základního kurzu',
        'ABSOLUTNÍ přednost při plánování jízd',
        'ABSOLUTNÍ přednost při zkoušce',
        'Připraven k zkoušce za měsíc',
        'Individuální přístup',
        'Bez čekání na ostatní',
        'Maximální flexibilita termínů',
        'VIP servis'
      ],
      included: [
        'Vše ze základního kurzu',
        'Prioritní plánování',
        'Expresní příprava',
        'VIP servis'
      ],
      badge: 'Nejrychlejší',
      class: 'express-badge'
    },
    {
      id: 3,
      name: 'SUV kurz',
      icon: "🚙",
      price: '26.500',
      originalPrice: null,
      specialOffer: null,
      description: 'Kurz s SUV vozidlem pro moderní řidiče',
      popular: false,
      vehicle: 'Dacia Duster SUV',
      duration: 'cca 2 měsíce',
      features: [
        '24 hodin jízdy s Dacia Duster',
        '2 hodiny noční jízdy',
        'První 2 hodiny na Škoda Fabia',
        'Doprava na autocvičiště zdarma',
        'Nástup/výstup na dohodnutém místě',
        'Procvičení všech situací',
        'Příprava na moderní vozidla'
      ],
      included: [
        'SUV výcvik',
        'Noční jízdy',
        'Doprava zdarma',
        'Moderní výuka'
      ],
      badge: 'SUV',
      class: 'suv-badge'
    }
  ]

  const feeCategories = [
    {
      title: 'Doplňkové služby',
      description: 'Přehled doplňkových služeb autoškoly',
      color: 'blue',
      fees: [
        {
          name: 'Kondiční jízda',
          price: '750',
          unit: 'za hodinu (45 min)',
          description: 'Škoda Fabia Combi'
        },
        {
          name: 'Přezkoušení odborné způsobilosti',
          price: '5.500',
          unit: 'kompletní',
          description: 'Škoda Fabia Combi'
        },
        {
          name: 'Předčasné ukončení/Přechod do jiné Autoškoly',
          price: '800',
          unit: 'jednorázově',
          description: 'Poplatek za vyřízení nezbytné administrativy'
        },
        {
          name: 'Kompletní opakování povinné výuky',
          price: '5500',
          description: 'po 3 neúspěšných zkouškách'
        }
      ]
    },
    {
      title: 'Správní poplatky státu',
      description: 'Úřední poplatky placené na městském úřadě',
      color: 'red',
      fees: [
        {
          name: 'Řádná zkouška',
          price: '700',
          unit: 'před první zkouškou',
          description: 'Teorie + praktická jízda'
        },
        {
          name: 'Opravný test',
          price: '100',
          description: 'Pouze teorie'
        },
        {
          name: 'Opravná praktická jízda',
          price: '400',
          description: 'Pouze praktická část'
        }
      ]
    },
    {
      title: 'Poplatky autoškole s její účastí',
      description: 'Za účast autoškoly na zkouškách',
      color: 'green',
      fees: [
        {
          name: 'První zkouška',
          price: '0',
          description: 'Přihlášení k první zkoušce'
        },
        {
          name: 'Opakovaná zkouška z testů',
          price: '0',
          description: 'Autoškola Příkaský Vám zdarma zařídí termín, ale opravné zkoušky se již neúčastní'
        },
        {
          name: 'Jakákoliv další zkouška',
          price: '1.000',
          description: 'S účastí autoškoly'
        },
        {
          name: 'Storno poplatek',
          price: '500',
          unit: 'jednorázově',
          description: 'Nenastoupení na jízdu bez omluvy (min. 24h předem)'
        },
      ]
    }
  ]

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cardIndex = parseInt(entry.target.dataset.index)
            setVisibleCards(prev => [...new Set([...prev, cardIndex])])
          }
        })
      },
      { threshold: 0.2 }
    )

    const cards = sectionRef.current?.querySelectorAll('.pricing-card')
    cards?.forEach(card => observer.observe(card))

    return () => observer.disconnect()
  }, [])

  const handleContactClick = () => {
    const element = document.getElementById('kontakt')
    if (element) {
      const headerHeight = window.innerWidth < 768 ? 80 : 100
      const elementPosition = element.offsetTop
      const offsetPosition = elementPosition - headerHeight

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }

  return (
    <div className="pricing-section" ref={sectionRef}>
      <div className="section-content">
        <div className="pricing-header">
          <h2>Náš ceník</h2>
          <p>Transparentní ceny bez skrytých poplatků</p>
          {/* <div className="special-notice">
            <span className="notice-icon">🎉</span>
            <span>Zaváděcí cena pro prvních 5 účastníků od října 2025 - 20.900 Kč</span>
          </div> */}
        </div>

        <div className="pricing-plans">
          {pricingPlans.map((plan, index) => (
            <div 
              key={plan.id}
              className={`pricing-card ${visibleCards.includes(index) ? 'visible' : ''} ${plan.popular ? 'popular' : ''}`}
              data-index={index}
            >
              {plan.popular && <div className="popular-badge">Nejoblíbenější</div>}
              {plan.badge && !plan.popular && <div className={`feature-badge ${plan.class.toLowerCase()}`}>{plan.badge}</div>}
              
              <div className="card-header">
                <h3>{plan.name}</h3>
                <div className="price-container">
                  <div className="main-price">
                    <span className="amount">{plan.price}</span>
                    <span className="currency">Kč</span>
                  </div>
                  {plan.specialOffer && (
                    <div className="special-price">
                      {plan.specialOffer}
                    </div>
                  )}
                </div>
                <p className="plan-description">{plan.description}</p>
              </div>

              <div className="card-body">
                <div className="plan-meta">
                  <div className="meta-item">
                    <span className="meta-icon">{plan.icon}</span>
                    <span>{plan.vehicle}</span>
                  </div>
                  <div className="meta-item">
                    <span className="meta-icon">⏱️</span>
                    <span>{plan.duration}</span>
                  </div>
                </div>

                <div className="features-list">
                  {plan.features.map((feature, idx) => (
                    <div key={idx} className="feature-item">
                      <span className="feature-check">✓</span>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="included-section">
                  <h4>V ceně zahrnuto:</h4>
                  <div className="included-tags">
                    {plan.included.map((item, idx) => (
                      <span key={idx} className="included-tag">{item}</span>
                    ))}
                  </div>
                </div>
              </div>

              <div className="card-glow"></div>
            </div>
          ))}
        </div>

        <div className="fee-categories">
          <h3>Přehled poplatků</h3>
          <div className="categories-grid">
            {feeCategories.map((category, index) => (
              <div key={index} className={`fee-category ${category.color}`}>
                <div className="category-header">
                  <h4>{category.title}</h4>
                  <p className="category-description">{category.description}</p>
                </div>
                <div className="fees-list">
                  {category.fees.map((fee, feeIndex) => (
                    <div key={feeIndex} className="fee-item">
                      <div className="fee-info">
                        <h5>{fee.name}</h5>
                        <p className="fee-description">{fee.description}</p>
                      </div>
                      <div className="fee-price">
                        <span className="price">{fee.price === '0' ? 'ZDARMA' : `${fee.price} Kč`}</span>
                        <span className="unit">{fee.unit}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="pricing-info">
          <div className="info-cards">
            <div className="info-card">
              <div className="info-icon">💳</div>
              <h4>Způsoby platby</h4>
              <p>hotovost, na fakturu, SODEXO/PLUXEE, DÁRKOVÝ PASS, BONUS PASS, SMART PASS, FLEXI PASS, FOKUS PASS, FLEXI karta</p>
            </div>
            <div className="info-card">
              <div className="info-icon">📋</div>
              <h4>Výukové materiály</h4>
              <p>Přístup k e-learningovým materiálům zdarma. Zapůjčení učebnice za vratnou zálohu 200 Kč.</p>
            </div>
            <div className="info-card">
              <div className="info-icon">⏰</div>
              <h4>Platnost kurzu</h4>
              <p>Kurz musí být dokončen do 12 měsíců od data prvního pokusu. Opakování každé části zkoušky je možné pouze dvakrát.</p>
            </div>
          </div>
        </div>

        <div className="pricing-cta">
          <div className="cta-content">
            <h3>Potřebujete poradit s výběrem kurzu?</h3>
            <p>Rádi vám pomůžeme najít nejlepší variantu podle vašich potřeb a časových možností</p>
            <div className="cta-buttons">
              <button className="btn btn-primary" onClick={handleContactClick}>
                Nezávazná konzultace
              </button>
              <a href="tel:728108824" className="btn btn-secondary">
                <span className="phone-icon">📞</span>
                728 108 824
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="pricing-background">
        <div className="bg-element element-1"></div>
        <div className="bg-element element-2"></div>
        <div className="bg-element element-3"></div>
      </div>
    </div>
  )
}

export default Cenik